export const STAND_QA_VERSION = "1.1.3";
